






























































































































import Vue from 'vue'

export default Vue.extend({
    name: 'Levels',
    metaInfo: {
        title: 'Levels of Maintenance and Retrofitting',
        meta : [
            {
                name: 'description',
                content : 'Select one of the levels of maintenance and retrofitting to learn more about how to keep a house safe in a windstorm.'
            },
            {
                name: 'keywords',
                content : 'Maintenance, window and door protection, retrofitting, tie-down chain, cyclone, weather, storm, protection'
            }
        ]
    },
    data: () => ({
        dense: true,
        items: [
            {
                color: "grey",
                icon: "mdi-hammer",
                header: "LEVEL 1: General Maintenance",
                text:
                    "Check for rust, termites, rot and moisture.",
                link: "/maintenance",
                hint: "Start here. This level offers protection at low cost."
            },
            {
                color: "grey darken-1",
                icon: "mdi-window-open",
                header: "LEVEL 2: Window and Door Protection",
                text: "Protect your windows and doors from debris and water ingress.",
                link: "/window",
                hint: "This level provides more protection."
            },
            {
                color: "grey darken-2",
                icon: "mdi-hammer-screwdriver",
                header: "LEVEL 3: Roof Tie-Down Retrofit",
                text:
                    "Select features of your house to get customised retrofitting details.",
                link: "/select",
                hint: "Try to reach this level as it provides the most protection.",
                star: true
            },

            /*{
                color: "#FFA726",
                icon: "",
                header: "LEVEL 4: Roof and Wall Tie-Down Retrofit.",
                text:
                    "Coming Up Soon.",
                link: "/todo",
                hint: "Coming Up Soon"
            }*/
        ]
    }),
    computed: {

    },
})
